module.exports = __webpack_public_path__ + "static/media/medicare-news.d9520ef4.jpg";